module.exports = __webpack_public_path__ + "img/mv.46b05aec.jpg";